module.exports = __webpack_public_path__ + "static/media/Marine-Safety-Equipments-Supply.c4575966.jpg";